<template>
  <admin-layout>
    <template slot="content">
      <create-or-update
          :mode="mode"
          :dialog="dialog"
          :item="item"
          @loadPage="loadPage(pageNumber)"
          @closeDialog="closeDialog()"
      ></create-or-update>

      <header-for-list-component
          sectionName="Tipos de Estudo Ambiental"
          :items="enviromentalStudyTypes"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar Tipo de Estudo Ambiental"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <v-btn
              color="primary"
              @click="selectItem(null)">
            <v-icon>mdi-plus</v-icon>
            Novo Tipo de Estudo Ambiental
          </v-btn>

        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="enviromentalStudyTypes"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.acronym }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.analysis_type === null ? 'Não há' : props.item.analysis_type.name
              }}
            </td>
            <td>
              <v-layout row>

                <v-btn
                    icon
                    @click="selectItem(props.item)">
                  <v-icon small>mdi-pencil</v-icon>

                </v-btn>

                <delete :item="props.item"
                        @loadPage="loadPage(pageNumber)"></delete>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
  import AdminLayout from '@/layouts/AdminLayout';

  import CreateOrUpdate from '@/components/configurations/enviromental_study_type/CreateOrUpdate';
  import Delete from '@/components/configurations/enviromental_study_type/Delete';

  import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
  import EnviromentalStudyTypeService from '@/services/applications/configurations/EnviromentalStudyTypeService';

  export default {
    name: 'List',
    components: {
      AdminLayout,
      HeaderForListComponent,
      CreateOrUpdate,
      Delete
    },
    mounted() {
      this.loadPage(1);
    },
    data() {
      return {
        item: null,
        search: '',
        enviromentalStudyTypes: [],
        loadingSearch: false,
        interval: null,
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 20,
        pageNumber: 1,
        headers: [
          { text: 'ID', value: 'id', sortable: false, align: 'center' },
          { text: 'Sigla', value: 'acronym', sortable: false, align: 'center' },
          { text: 'Nome', value: 'name', sortable: false, align: 'center' },
          { text: 'Cobrança de Análise', value: 'name', sortable: false, align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false, align: 'center' }],
        dialog: false,
        mode: 'create',
      };
    },
    methods: {
      loadPage(pageNumber) {
        this.pageNumber = pageNumber || this.pageNumber;
        if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
        EnviromentalStudyTypeService
          .all({
            limit: this.itemsPerPage,
            page: this.pageNumber,
            q: this.search,
          })
          .then(({ data }) => {
            this.enviromentalStudyTypes = data.enviromental_study_types || [];
            this.totalItems = data.total;
            this.totalPages = data.total_pages;
          })
          .finally(() => {
            this.$store.dispatch('setLoadingDialog', false);
            this.loadingSearch = false;
          });
      },
      typing() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.pageNumber = 1;
          this.loadPage();
        }, 500);
      },
      selectItem(item) {
        this.mode = item === null ? 'create' : 'update';
        this.item = item;
        this.dialog = true;
      },
      closeDialog(){
        this.dialog = false;
      }

    },
  };
</script>

<style scoped lang="scss">
</style>
